/*
 * ALOHA QUEEN SUPERNOVA - Dynamic Animated Cards
 * Copyright © 2025 Malcolm KH Lee III. All Rights Reserved.
 */

import React, { useState } from 'react';

const DynamicGradientCard = ({ children, className = '', gradient = 'purple' }) => {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [isHovered, setIsHovered] = useState(false);

  const gradients = {
    purple: 'from-purple-600 via-pink-600 to-blue-600',
    gold: 'from-yellow-500 via-orange-500 to-red-500',
    ocean: 'from-blue-500 via-cyan-500 to-teal-500',
    royal: 'from-purple-700 via-pink-600 to-yellow-500',
    neon: 'from-green-400 via-blue-500 to-purple-600'
  };

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePos({
      x: ((e.clientX - rect.left) / rect.width) * 100,
      y: ((e.clientY - rect.top) / rect.height) * 100
    });
  };

  return (
    <div
      className={`relative group ${className}`}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        transform: isHovered ? 'translateY(-8px) scale(1.02)' : 'translateY(0) scale(1)',
        transition: 'all 0.3s ease'
      }}
    >
      {/* Animated gradient border */}
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-r opacity-0 group-hover:opacity-100 blur-xl transition-opacity duration-500"
        style={{
          background: `radial-gradient(circle at ${mousePos.x}% ${mousePos.y}%, rgba(255,215,0,0.4), rgba(255,20,147,0.4), rgba(138,43,226,0.4))`
        }}
      />
      
      {/* Main card */}
      <div className={`relative bg-gradient-to-br ${gradients[gradient]} p-[2px] rounded-2xl overflow-hidden`}>
        <div className="absolute inset-0 bg-gradient-to-br opacity-50 animate-pulse"
          style={{
            background: `radial-gradient(circle at ${mousePos.x}% ${mousePos.y}%, rgba(255,255,255,0.3), transparent 60%)`
          }}
        />
        <div className="relative bg-gray-900/95 backdrop-blur-sm rounded-2xl p-6">
          {children}
        </div>
      </div>
    </div>
  );
};

export default DynamicGradientCard;